import styled from 'styled-components';
import { Form, Row, Well } from 'react-bootstrap';
import { FormGroup, Nav, NavItem } from 'react-bootstrap';

export const GridWrapper = styled.div`
    width: 100%;
    height: 76vh;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: ${p => p.isAdmin ? '#133666' : '#ddd'};
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-size: 13px;
    }

    .ag-header-row {
        color: ${p => p.isAdmin ? 'white' : '#123'} !important;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    div.ag-root .ag-cell-focus {
        user-select: text !important;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 20px;
        border-color: #ccc;
        font-size: 13px;
    }

    .list-cell > .ag-cell-wrapper {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .list-cell > .ag-cell-wrapper > .ag-cell-value,
    .list-cell > .ag-cell-wrapper > .ag-cell-value > .ag-react-container {
        width: 100%;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #eee;
        border-width: 0px 0px 0px 1px;
        border-style: solid;
        padding-bottom: 5px;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customSortDownLabel {
        margin-left: 3px;
    }

    .customSortUpLabel {
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }

    .ag-react-container {
        text-align: center;
    }

    @media screen and (width < 1920px) {
        .ag-header, .ag-cell {
            font-size: 12px;
        }
    }
`;

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string,
    fontSize?: string
}

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    & > .acc-tabs > li {
        height: 48px;
    }

    & > .acc-tabs > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        text-align: center;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > .acc-tabs > li.active > a {
        color: #555;
        background-color: #fff;
    }

    & > div > .ms-pills > li > a {
        padding: 5px 7px;
    }

    & > div > .ms-pills > li > span {
        position: relative;
        display: block;
        font-size: 12px;
        padding: 5px 2px;
        color: #ccc;
    }

    & > div > .ms-pills > li.li-divider {
        height: 50px;
        display: flex;
        align-items: center;
    }

    & > div > .ms-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }
`;

interface INavItemProps {
    minTabWidth?: string
}

export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    height: 50px;
    display: flex !important;
    align-items: center;
    text-align: center;

    & > a > span.badge {
        font-size: 10px;
    }

    & > a > span.type-count {
        font-size: 12px;
    }
`;

export const RowWrapper = styled(Row)`
    margin-bottom: 10px;
    display: flex;
    align-items: center;
`;

export const ViewWrapper = styled(Form)`
    .modal-container {
        position: relative;
    }

    .modal-container .modal, .modal-container .modal-backdrop {
        position: absolute;
    }
`;

export const FormGroupWrapper = styled(FormGroup)`
    margin-bottom: 5px;
`;

export const TabsWrapper = styled.div`
    .nav > li > a,
    .nav > li.active > a {
        font-size: 14px !important;
        color: #006;
    }

    .nav > li.active > a {
        background-color: #ccc !important;
    }

    .nav > li.on > a {
        background-color: white;
    }
`;

export const PillWrapper = styled.li`
    & > a {
        border: ${p => p.className == null ? "1px solid darkgrey !important" : "1px solid #337ab7"};
    }

    margin-right: 5px;
`;

export const WellWrapper = styled(Well)`
    margin-bottom: 5px;
    
    h4, .h4, h5, .h5, h6, .h6 {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .btn-group label.btn-default.active {
        background-color: #2D6CA2;
        color: white;
        //text-shadow: 0 0 0 #FFF;
        outline: none;
    }

    .filter-group .btn-group {
        display: flex;
    }

    .filter-group .btn-group .btn {
        white-space: nowrap;
        flex-shrink: 0;
    }

    .filter-flex {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
    }

    @media (min-width: 1200px) {
        .filter-flex {
            flex-wrap: nowrap;
        }
    }

   @media (min-width: 1200px) {
        .filter-group.shift-right-lg {
            padding-left: 55px;
        }
    }
        
`;

export const RecipientSelectWrapper = styled.div`
    padding-top: ${p => p.isRecipient ? '3px' : '5px'};
    padding-bottom: ${p => p.isRecipient ? '0px' : '3px'};
`;

export const recipientSelectCustomStyles = (isRecipient: boolean) => ({
    container: (provided) => ({
        ...provided,
        minHeight: isRecipient ? 26 : 22,
        minWidth: 200,
        height: 22
    }),
    control: (base) => ({
        ...base,
        minHeight: isRecipient ? 26 : 22,
        padding: 0,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        boxShadow: '0 none',
        height: 26
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        minHeight: isRecipient ? 26 : 22,
        height: 26
    }),
    clearIndicator: (provided) => ({
        ...provided,
        minHeight: isRecipient ? 26 : 22,
        padding: 3
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        minHeight: isRecipient ? 26 : 22,
        padding: '0px 3px'
    }),
    indicatorSeparator: () => ({
        color: "white"
    }),
    valueContainer: (provided) => ({
        ...provided,
        // top: '-1px',
        padding: isRecipient ? '0px 8px' : '0px 8px',
        height: 26
    }),
    multiValue: (provided) => ({
        ...provided,
        marginTop: 0
    }),
    placeholder: (provided) => ({
        ...provided,
    }),
    singleValue: (provided) => ({
        ...provided,
        top: '50%',
        fontSize: 12
    }),
    menuList: (provided) => ({
        ...provided,
    }),
    option: (provided, state) => ({
        ...provided,
        paddingTop: 2,
        paddingBottom: 2,
        fontSize: 12,
        ':hover': {
            backgroundColor: 'lightblue', // Change the background color on hover
            cursor: 'pointer', // Change the cursor on hover
        },
    })
});